/** `<html data-input-modality>` attribute name, mirrored by a comment beside
 *  the CSS rule in `global.css` that reads it. */
export const INPUT_MODALITY_ATTRIBUTE = 'data-input-modality';
/** Attribute values `installDocumentInputModality` writes. */
export const INPUT_MODALITY_POINTER = 'pointer';
export const INPUT_MODALITY_KEYBOARD = 'keyboard';

/** Installs capture-phase pointerdown/keydown listeners on the document and mirrors the last
 *  input kind onto <html data-input-modality="pointer|keyboard">. Returns an uninstall fn. */
export function installDocumentInputModality(targetDocument: Document = document): () => void {
  const handlePointerDown = () => {
    targetDocument.documentElement.setAttribute(INPUT_MODALITY_ATTRIBUTE, INPUT_MODALITY_POINTER);
  };
  const handleKeyDown = () => {
    targetDocument.documentElement.setAttribute(INPUT_MODALITY_ATTRIBUTE, INPUT_MODALITY_KEYBOARD);
  };

  targetDocument.addEventListener('pointerdown', handlePointerDown, true);
  targetDocument.addEventListener('keydown', handleKeyDown, true);

  return () => {
    targetDocument.removeEventListener('pointerdown', handlePointerDown, true);
    targetDocument.removeEventListener('keydown', handleKeyDown, true);
  };
}
